export const baseURL = "https://hotel-book-com-server-deploy.vercel.app/api/v1";